<div class="tab-contents">
    <div class="site-roles-list">
        <strong>Site-Level Roles</strong><br />
        Automatically applied to all folder levels of the tree
        <ng-container *ngFor="let role of SiteLevelRoles">
            <mat-expansion-panel [hideToggle]="siteLevelRoleMemberCount(role) == 0">
                <mat-expansion-panel-header>
                    <mat-panel-title [ngClass]="{'greyed-out':false}">
                        <div class="role-title" title="Role ID {{role.id}}">
                            <span class="role-member-count">
                                <mat-icon title="Role Members" class="role-member-count-icon">group</mat-icon>
                                {{this.siteLevelRoleMemberCount(role)}}
                            </span>
                        </div>
                        <div>
                            <strong class="role-name" title="Role ID {{role.id}}">{{role.name}}</strong>
                        </div>
                    </mat-panel-title>
                    <mat-panel-description class="role-buttons">
                        <mat-icon (click)="openRoleDrawer({event:$event, entityName:title, role:role})"
                                  (keyup.enter)="openRoleDrawer({event:$event, entityName:title, role:role})"
                                  matTooltip="{{getTitleForManageRolesIcon()}}"
                                  tabindex="0"
                                  [ngClass]="{'greyed-out':false}">person_add</mat-icon>
                        <mat-icon (click)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                                  tabindex="0"
                                  (keyup.enter)="openEditRoleDialog({event:$event, entityName:title, role:role})"
                                  title="Edit Role Details">edit</mat-icon>
                        <mat-icon *ngIf="role.countOfSiteLevelMembers() == 0"
                                  (click)="deleteRole($event, role)"
                                  tabindex="1"
                                  (keyup.enter)="deleteRole($event, role)"
                                  title="Delete Role">delete</mat-icon>
                        <mat-icon *ngIf="role.countOfSiteLevelMembers() > 0"
                                  tabindex="1"
                                  class="greyed-out"
                                  matTooltip="You cannot delete roles with members. To delete this role, first delete its members">delete</mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="role-member-list">
                    <div *ngFor="let member of this.getSiteRoleMembers(role)" class="role-member" [ngClass]="{'greyed-out':membersAreInherited}">
                        <span>{{member.member}}</span>
                    </div>
                </div>
            </mat-expansion-panel>
        </ng-container>
        <button class="new-role-btn theme-primary-btn" mat-flat-button color="primary" (click)="this.openCreateRoleDialog()">New Role</button>
    </div>
</div>
